import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonos = [{
    num: '01',
    title: 'BONO 1 — Kit de Implementación Express',
    subtitle: '7 Noches Para Transformar Tu Sueño',
    desc: 'El sistema acelerado para empezar esta noche. Sin leer todo el megapack primero. Resultados en 7 días.',
    price: '$8.000'
  }, {
    num: '02',
    title: 'BONO 2 — Checklist Antidesvelo',
    subtitle: '5 Minutos Para Eliminar los Sabotajes',
    desc: 'La lista exacta de lo que estás haciendo mal cada noche. Identificá y eliminá tus sabotajes en menos de 5 minutos.',
    price: '$8.000'
  }, {
    num: '03',
    title: 'BONO 3 — Menú Nocturno Pro-Sueño',
    subtitle: 'Cenas Que Construyen Tu Descanso',
    desc: '7 cenas semanales completas, 5 opciones express y la hoja printable para la heladera. Nunca más vas a dudar qué cenar.',
    price: '$9.000'
  }, {
    num: '04',
    title: 'BONO 4 — Ritual Nocturno de 10 Minutos',
    subtitle: 'La Rutina Mínima Que Sí Vas a Poder Sostener',
    desc: 'El protocolo 3-3-3-1 que instala el hábito sin fuerza de voluntad. Funciona incluso las noches más caóticas.',
    price: '$9.000'
  }, {
    num: '05',
    title: 'BONO 5 — Tracker de Sabotajes del Sueño',
    subtitle: 'Del Caos a la Claridad — Tus Patrones Revelados',
    desc: 'El sistema de 14 días para identificar exactamente qué destruye TU sueño específico. Con datos, no suposiciones.',
    price: '$8.000'
  }, {
    num: '06',
    title: 'BONO 6 — Guía de Emergencia',
    subtitle: 'Protocolo Para Despertares Nocturnos',
    desc: 'Lo que hacés en los primeros 60 segundos después de despertarte define si volvés a dormir en 10 minutos o seguís despierto 2 horas. Este bono te da el protocolo exacto.',
    price: '$9.000'
  }];
  return <section className="py-24 relative bg-slate-900/80 border-y border-white/5" data-id="element-3">
      <div className="container mx-auto px-4" data-id="element-4">
        <div className="text-center mb-16" data-id="element-5">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal-500/10 text-teal-400 mb-6 border border-teal-500/20" data-id="element-6">
            <Gift size={32} data-id="element-7" />
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-8">
            <span aria-hidden="true" data-id="element-9">🎁</span> 6 BONOS ESTRATÉGICOS
          </h2>
          <div className="inline-block px-4 py-1.5 rounded-full bg-teal-500/20 text-teal-300 text-sm font-bold tracking-widest uppercase border border-teal-500/30" data-id="element-10">
            SIEMPRE INCLUIDOS
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16" data-id="element-11">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative p-8 rounded-2xl bg-slate-800/40 border border-white/10 overflow-hidden group" data-id="element-12">
              <div className="absolute top-0 right-0 p-6 text-6xl font-display font-bold text-white/5 select-none pointer-events-none group-hover:text-white/10 transition-colors" data-id="element-13">
                {bono.num}
              </div>

              <div className="relative z-10" data-id="element-14">
                <h3 className="text-xl font-bold text-white mb-1 flex items-center gap-2" data-id="element-15">
                  <span aria-hidden="true" data-id="element-16">🎁</span> {bono.title}
                </h3>
                <h4 className="text-sm font-medium text-teal-400 mb-4" data-id="element-17">
                  {bono.subtitle}
                </h4>
                <p className="text-slate-400 leading-relaxed text-sm mb-6" data-id="element-18">
                  {bono.desc}
                </p>

                <div className="flex items-center gap-3 pt-4 border-t border-white/10" data-id="element-19">
                  <span className="text-slate-500 line-through font-medium" data-id="element-20">
                    {bono.price}
                  </span>
                  <span className="text-teal-400 font-bold" data-id="element-21">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto text-center p-6 rounded-2xl bg-gradient-to-r from-teal-900/20 via-slate-800/50 to-teal-900/20 border border-teal-500/20" data-id="element-22">
          <p className="text-xl md:text-2xl font-medium text-slate-300" data-id="element-23">
            Valor total bonos{' '}
            <span className="line-through text-slate-500 mx-2" data-id="element-24">$51.000</span>{' '}
            <span className="text-teal-400 font-bold" data-id="element-25">
              → GRATIS con tu Megapack
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}